import { render, staticRenderFns } from "./TasksRequestSection.vue?vue&type=template&id=0c6b98fe&"
import script from "./TasksRequestSection.vue?vue&type=script&lang=js&"
export * from "./TasksRequestSection.vue?vue&type=script&lang=js&"
import style0 from "./TasksRequestSection.vue?vue&type=style&index=0&id=0c6b98fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports